var _defs, _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 51,
    viewBox: "0 0 917 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "krit-logo-wordmark-only"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 917,
    height: 190
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#krit-logo-wordmark-only)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,1 L19,1 L19,0 L20,0 L20,1 L27,1 L27,0 L37,0 L37,1 L38,1 L38,0 L39,0 L39,1 L40,1 L40,0 L51,0 L51,1 L75,1 L75,2 L81,2 L81,3 L85,3 L85,4 L88,4 L88,5 L90,5 L90,6 L92,6 L92,7 L94,7 L94,8 L96,8 L96,9 L98,9 L98,10 L99,10 L99,11 L101,11 L101,12 L102,12 L102,13 L103,13 L103,14 L104,14 L104,15 L105,15 L105,16 L106,16 L106,17 L107,17 L107,18 L108,18 L108,19 L109,19 L109,21 L110,21 L110,22 L111,22 L111,24 L112,24 L112,26 L113,26 L113,28 L114,28 L114,31 L115,31 L115,35 L116,35 L116,41 L117,41 L117,51 L116,51 L116,56 L115,56 L115,60 L114,60 L114,63 L113,63 L113,65 L112,65 L112,67 L111,67 L111,69 L110,69 L110,71 L109,71 L109,72 L108,72 L108,74 L106,74 L106,76 L105,76 L105,77 L103,77 L103,78 L102,78 L102,79 L101,79 L101,80 L100,80 L100,81 L98,81 L98,82 L97,82 L97,83 L95,83 L95,84 L96,84 L96,86 L97,86 L97,88 L98,88 L98,89 L99,89 L99,91 L100,91 L100,93 L101,93 L101,94 L102,94 L102,96 L103,96 L103,98 L104,98 L104,99 L105,99 L105,101 L106,101 L106,103 L107,103 L107,104 L108,104 L108,106 L109,106 L109,108 L110,108 L110,109 L111,109 L111,111 L112,111 L112,112 L113,112 L113,114 L114,114 L114,116 L115,116 L115,117 L116,117 L116,119 L117,119 L117,120 L118,120 L118,122 L119,122 L119,124 L120,124 L120,125 L121,125 L121,127 L122,127 L122,128 L123,128 L123,130 L118,130 L118,131 L117,131 L117,130 L73,130 L73,129 L72,129 L72,128 L71,128 L71,126 L70,126 L70,125 L69,125 L69,123 L68,123 L68,121 L67,121 L67,120 L66,120 L66,118 L65,118 L65,116 L64,116 L64,115 L63,115 L63,113 L62,113 L62,111 L61,111 L61,110 L60,110 L60,108 L59,108 L59,106 L58,106 L58,105 L57,105 L57,103 L56,103 L56,101 L55,101 L55,100 L54,100 L54,98 L53,98 L53,96 L52,96 L52,95 L51,95 L51,93 L50,93 L50,91 L49,91 L49,90 L48,90 L48,88 L47,88 L47,90 L46,90 L46,94 L47,94 L47,122 L46,122 L46,123 L47,123 L47,129 L46,129 L46,130 L0,130 Z M47,32 L47,34 L46,34 L46,35 L47,35 L47,36 L46,36 L46,38 L47,38 L47,47 L46,47 L46,48 L47,48 L47,49 L46,49 L46,54 L47,54 L47,56 L46,56 L46,59 L47,59 L47,60 L46,60 L46,61 L59,61 L59,60 L62,60 L62,59 L64,59 L64,58 L66,58 L66,57 L67,57 L67,56 L68,56 L68,55 L69,55 L69,53 L70,53 L70,49 L71,49 L71,44 L70,44 L70,41 L69,41 L69,39 L67,39 L67,38 L68,38 L68,37 L66,37 L66,36 L65,36 L65,35 L63,35 L63,34 L61,34 L61,33 L53,33 L53,32 L52,32 L52,34 L51,34 L51,32 L50,32 L50,33 L48,33 L48,32 Z M46,87 L46,88 L47,88 L47,87 Z ",
    fill: "#000000",
    transform: "translate(172,44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L8,1 L8,2 L9,2 L9,1 L17,1 L17,2 L18,2 L18,1 L19,1 L19,2 L21,2 L21,1 L22,1 L22,3 L21,3 L21,5 L20,5 L20,7 L19,7 L19,8 L18,8 L18,10 L17,10 L17,12 L16,12 L16,13 L15,13 L15,15 L14,15 L14,16 L13,16 L13,18 L12,18 L12,20 L11,20 L11,21 L10,21 L10,23 L9,23 L9,24 L8,24 L8,26 L7,26 L7,28 L6,28 L6,29 L5,29 L5,31 L4,31 L4,33 L3,33 L3,34 L2,34 L2,36 L1,36 L1,37 L0,37 L0,39 L-1,39 L-1,40 L-2,40 L-2,42 L-3,42 L-3,43 L-4,43 L-4,45 L-5,45 L-5,47 L-6,47 L-6,48 L-7,48 L-7,50 L-8,50 L-8,52 L-9,52 L-9,53 L-10,53 L-10,55 L-11,55 L-11,56 L-12,56 L-12,58 L-13,58 L-13,59 L-14,59 L-14,61 L-15,61 L-15,63 L-16,63 L-16,65 L-17,65 L-17,66 L-18,66 L-18,67 L-17,67 L-17,69 L-16,69 L-16,70 L-15,70 L-15,72 L-14,72 L-14,73 L-13,73 L-13,75 L-12,75 L-12,77 L-11,77 L-11,78 L-10,78 L-10,80 L-9,80 L-9,81 L-8,81 L-8,83 L-7,83 L-7,85 L-6,85 L-6,86 L-5,86 L-5,88 L-4,88 L-4,89 L-3,89 L-3,91 L-2,91 L-2,92 L-1,92 L-1,94 L0,94 L0,96 L1,96 L1,97 L2,97 L2,99 L3,99 L3,101 L4,101 L4,102 L5,102 L5,104 L6,104 L6,105 L7,105 L7,107 L8,107 L8,108 L9,108 L9,110 L10,110 L10,112 L11,112 L11,113 L12,113 L12,115 L13,115 L13,116 L14,116 L14,118 L15,118 L15,120 L16,120 L16,121 L17,121 L17,123 L18,123 L18,124 L19,124 L19,126 L20,126 L20,128 L21,128 L21,129 L22,129 L22,130 L21,130 L21,131 L-29,131 L-29,130 L-30,130 L-30,128 L-31,128 L-31,127 L-32,127 L-32,125 L-33,125 L-33,123 L-34,123 L-34,122 L-35,122 L-35,120 L-36,120 L-36,118 L-37,118 L-37,117 L-38,117 L-38,115 L-39,115 L-39,113 L-40,113 L-40,112 L-41,112 L-41,110 L-42,110 L-42,109 L-43,109 L-43,107 L-44,107 L-44,105 L-45,105 L-45,104 L-46,104 L-46,102 L-47,102 L-47,101 L-48,101 L-48,99 L-49,99 L-49,97 L-50,97 L-50,96 L-51,96 L-51,94 L-52,94 L-52,93 L-53,93 L-53,91 L-54,91 L-54,89 L-55,89 L-55,88 L-56,88 L-56,86 L-57,86 L-57,84 L-58,84 L-58,83 L-59,83 L-59,81 L-60,81 L-60,84 L-61,84 L-61,85 L-60,85 L-60,88 L-61,88 L-61,89 L-60,89 L-60,92 L-61,92 L-61,131 L-105,131 L-105,128 L-106,128 L-106,127 L-105,127 L-105,125 L-106,125 L-106,124 L-105,124 L-105,16 L-106,16 L-106,15 L-105,15 L-105,12 L-106,12 L-106,11 L-105,11 L-105,3 L-106,3 L-106,2 L-100,2 L-100,1 L-99,1 L-99,2 L-93,2 L-93,1 L-90,1 L-90,2 L-87,2 L-87,1 L-86,1 L-86,2 L-73,2 L-73,1 L-72,1 L-72,2 L-71,2 L-71,1 L-66,1 L-66,2 L-65,2 L-65,1 L-61,1 L-61,2 L-60,2 L-60,3 L-61,3 L-61,5 L-60,5 L-60,8 L-61,8 L-61,15 L-60,15 L-60,27 L-61,27 L-61,32 L-60,32 L-60,33 L-61,33 L-61,34 L-60,34 L-60,35 L-61,35 L-61,37 L-60,37 L-60,38 L-61,38 L-61,40 L-60,40 L-60,44 L-61,44 L-61,45 L-60,45 L-60,46 L-61,46 L-61,47 L-60,47 L-60,52 L-61,52 L-61,53 L-60,53 L-60,54 L-61,54 L-61,56 L-60,56 L-60,55 L-59,55 L-59,53 L-58,53 L-58,51 L-57,51 L-57,50 L-56,50 L-56,48 L-55,48 L-55,47 L-54,47 L-54,45 L-53,45 L-53,43 L-52,43 L-52,41 L-51,41 L-51,40 L-50,40 L-50,38 L-49,38 L-49,37 L-48,37 L-48,35 L-47,35 L-47,33 L-46,33 L-46,31 L-45,31 L-45,30 L-44,30 L-44,28 L-43,28 L-43,26 L-42,26 L-42,25 L-41,25 L-41,23 L-40,23 L-40,22 L-39,22 L-39,20 L-38,20 L-38,18 L-37,18 L-37,16 L-36,16 L-36,15 L-35,15 L-35,13 L-34,13 L-34,12 L-33,12 L-33,10 L-32,10 L-32,8 L-31,8 L-31,6 L-30,6 L-30,5 L-29,5 L-29,3 L-28,3 L-28,2 L-27,2 L-27,1 L-18,1 L-18,2 L-17,2 L-17,1 L-15,1 L-15,2 L-14,2 L-14,1 L-10,1 L-10,2 L-9,2 L-9,1 L-8,1 L-8,2 L-7,2 L-7,1 L0,1 Z M-61,80 L-61,81 L-60,81 L-60,80 Z ",
    fill: "#000000",
    transform: "translate(144,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L4,1 L4,2 L5,2 L5,3 L4,3 L4,9 L3,9 L3,16 L2,16 L2,26 L1,26 L1,34 L0,34 L0,36 L-3,36 L-3,35 L-9,35 L-9,36 L-20,36 L-20,35 L-21,35 L-21,36 L-32,36 L-32,37 L-31,37 L-31,42 L-32,42 L-32,56 L-31,56 L-31,57 L-32,57 L-32,64 L-31,64 L-31,66 L-32,66 L-32,68 L-31,68 L-31,74 L-32,74 L-32,78 L-31,78 L-31,82 L-32,82 L-32,85 L-31,85 L-31,89 L-32,89 L-32,92 L-31,92 L-31,93 L-32,93 L-32,94 L-31,94 L-31,97 L-32,97 L-32,102 L-31,102 L-31,106 L-32,106 L-32,112 L-31,112 L-31,114 L-32,114 L-32,116 L-31,116 L-31,130 L-32,130 L-32,131 L-77,131 L-77,132 L-78,132 L-78,76 L-79,76 L-79,78 L-80,78 L-80,75 L-78,75 L-78,68 L-80,68 L-80,67 L-78,67 L-78,38 L-79,38 L-79,37 L-78,37 L-78,36 L-88,36 L-88,35 L-89,35 L-89,36 L-100,36 L-100,35 L-102,35 L-102,36 L-104,36 L-104,35 L-106,35 L-106,36 L-108,36 L-108,33 L-109,33 L-109,32 L-108,32 L-108,1 L-104,1 L-104,2 L-102,2 L-102,1 L-98,1 L-98,2 L-93,2 L-93,1 L-88,1 L-88,2 L-86,2 L-86,1 L-84,1 L-84,2 L-83,2 L-83,1 L-82,1 L-82,2 L-78,2 L-78,1 L-77,1 L-77,2 L-76,2 L-76,1 L-75,1 L-75,2 L-73,2 L-73,1 L-72,1 L-72,2 L-69,2 L-69,1 L-66,1 L-66,2 L-53,2 L-53,1 L-51,1 L-51,2 L-50,2 L-50,1 L-48,1 L-48,2 L-44,2 L-44,1 L-43,1 L-43,2 L-42,2 L-42,1 L-40,1 L-40,2 L-38,2 L-38,1 L-35,1 L-35,2 L-34,2 L-34,1 L-32,1 L-32,2 L-31,2 L-31,1 L-27,1 L-27,2 L-25,2 L-25,1 L-23,1 L-23,2 L-22,2 L-22,1 L-8,1 L-8,2 L-6,2 L-6,1 L0,1 Z ",
    fill: "#000001",
    transform: "translate(464,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15,0 L15,1 L16,1 L16,0 L17,0 L17,1 L25,1 L25,2 L29,2 L29,3 L32,3 L32,4 L33,4 L33,3 L34,3 L34,9 L33,9 L33,16 L32,16 L32,23 L31,23 L31,27 L29,27 L29,26 L26,26 L26,25 L21,25 L21,24 L3,24 L3,25 L-1,25 L-1,26 L-5,26 L-5,27 L-7,27 L-7,28 L-10,28 L-10,29 L-12,29 L-12,30 L-14,30 L-14,31 L-16,31 L-16,32 L-17,32 L-17,33 L-19,33 L-19,34 L-20,34 L-20,35 L-21,35 L-21,36 L-22,36 L-22,37 L-23,37 L-23,38 L-24,38 L-24,39 L-25,39 L-25,40 L-26,40 L-26,41 L-27,41 L-27,42 L-28,42 L-28,44 L-29,44 L-29,45 L-30,45 L-30,47 L-31,47 L-31,48 L-32,48 L-32,50 L-33,50 L-33,52 L-34,52 L-34,54 L-35,54 L-35,57 L-36,57 L-36,59 L-37,59 L-37,63 L-38,63 L-38,67 L-39,67 L-39,74 L-40,74 L-40,84 L-39,84 L-39,91 L-38,91 L-38,94 L-37,94 L-37,97 L-36,97 L-36,98 L-35,98 L-35,100 L-34,100 L-34,101 L-33,101 L-33,102 L-32,102 L-32,103 L-31,103 L-31,104 L-29,104 L-29,105 L-28,105 L-28,106 L-26,106 L-26,107 L-23,107 L-23,108 L-18,108 L-18,109 L-3,109 L-3,108 L1,108 L1,107 L5,107 L5,106 L8,106 L8,105 L11,105 L11,104 L13,104 L13,103 L15,103 L15,102 L16,102 L16,109 L15,109 L15,115 L14,115 L14,122 L13,122 L13,127 L12,127 L12,128 L9,128 L9,129 L5,129 L5,130 L1,130 L1,131 L-5,131 L-5,132 L-14,132 L-14,133 L-29,133 L-29,132 L-38,132 L-38,131 L-43,131 L-43,130 L-46,130 L-46,129 L-48,129 L-48,128 L-51,128 L-51,127 L-53,127 L-53,126 L-55,126 L-55,125 L-56,125 L-56,124 L-58,124 L-58,123 L-59,123 L-59,122 L-60,122 L-60,121 L-62,121 L-62,119 L-64,119 L-64,117 L-65,117 L-65,116 L-66,116 L-66,115 L-67,115 L-67,113 L-68,113 L-68,112 L-69,112 L-69,110 L-70,110 L-70,108 L-71,108 L-71,106 L-72,106 L-72,104 L-73,104 L-73,101 L-74,101 L-74,96 L-75,96 L-75,86 L-76,86 L-76,81 L-75,81 L-75,70 L-74,70 L-74,65 L-73,65 L-73,61 L-72,61 L-72,58 L-71,58 L-71,55 L-70,55 L-70,52 L-69,52 L-69,50 L-68,50 L-68,47 L-67,47 L-67,45 L-66,45 L-66,43 L-65,43 L-65,41 L-64,41 L-64,40 L-63,40 L-63,38 L-62,38 L-62,36 L-61,36 L-61,35 L-60,35 L-60,33 L-59,33 L-59,32 L-58,32 L-58,31 L-57,31 L-57,29 L-56,29 L-56,28 L-55,28 L-55,27 L-54,27 L-54,26 L-53,26 L-53,25 L-52,25 L-52,24 L-51,24 L-51,23 L-50,23 L-50,22 L-49,22 L-49,21 L-48,21 L-48,20 L-47,20 L-47,19 L-46,19 L-46,18 L-45,18 L-45,17 L-43,17 L-43,16 L-42,16 L-42,15 L-40,15 L-40,14 L-39,14 L-39,13 L-37,13 L-37,12 L-36,12 L-36,11 L-34,11 L-34,10 L-32,10 L-32,9 L-30,9 L-30,8 L-28,8 L-28,7 L-26,7 L-26,6 L-23,6 L-23,5 L-21,5 L-21,4 L-17,4 L-17,3 L-13,3 L-13,2 L-8,2 L-8,1 L0,1 Z ",
    fill: "#004ED3",
    transform: "translate(535,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,0 L7,1 L8,1 L8,0 L24,0 L24,1 L25,1 L25,0 L26,0 L26,8 L25,8 L25,14 L24,14 L24,21 L23,21 L23,26 L22,26 L22,32 L21,32 L21,39 L20,39 L20,45 L19,45 L19,51 L18,51 L18,57 L17,57 L17,65 L16,65 L16,71 L15,71 L15,77 L14,77 L14,83 L13,83 L13,89 L12,89 L12,96 L11,96 L11,102 L10,102 L10,109 L9,109 L9,116 L8,116 L8,122 L7,122 L7,127 L4,127 L4,126 L-11,126 L-11,127 L-12,127 L-12,126 L-13,126 L-13,127 L-15,127 L-15,126 L-18,126 L-18,125 L-17,125 L-17,116 L-16,116 L-16,114 L-17,114 L-17,115 L-18,115 L-18,117 L-19,117 L-19,118 L-20,118 L-20,119 L-21,119 L-21,120 L-22,120 L-22,121 L-23,121 L-23,122 L-25,122 L-25,123 L-26,123 L-26,124 L-28,124 L-28,125 L-30,125 L-30,126 L-32,126 L-32,127 L-35,127 L-35,128 L-38,128 L-38,129 L-49,129 L-49,128 L-53,128 L-53,127 L-54,127 L-54,128 L-55,128 L-55,126 L-57,126 L-57,125 L-58,125 L-58,124 L-59,124 L-59,123 L-60,123 L-60,122 L-61,122 L-61,121 L-62,121 L-62,119 L-63,119 L-63,117 L-64,117 L-64,115 L-65,115 L-65,111 L-66,111 L-66,102 L-67,102 L-67,96 L-66,96 L-66,85 L-65,85 L-65,80 L-64,80 L-64,75 L-63,75 L-63,72 L-62,72 L-62,68 L-61,68 L-61,66 L-60,66 L-60,64 L-59,64 L-59,61 L-58,61 L-58,59 L-57,59 L-57,57 L-56,57 L-56,56 L-55,56 L-55,54 L-54,54 L-54,53 L-53,53 L-53,51 L-52,51 L-52,50 L-51,50 L-51,49 L-50,49 L-50,48 L-49,48 L-49,46 L-48,46 L-48,45 L-46,45 L-46,44 L-45,44 L-45,43 L-44,43 L-44,42 L-42,42 L-42,41 L-40,41 L-40,40 L-39,40 L-39,39 L-37,39 L-37,38 L-33,38 L-33,37 L-28,37 L-28,36 L-18,36 L-18,37 L-15,37 L-15,38 L-12,38 L-12,39 L-10,39 L-10,40 L-8,40 L-8,41 L-7,41 L-7,39 L-6,39 L-6,33 L-5,33 L-5,27 L-4,27 L-4,20 L-3,20 L-3,14 L-2,14 L-2,7 L-1,7 L-1,1 L0,1 Z M-21,55 L-21,56 L-24,56 L-24,57 L-25,57 L-25,58 L-26,58 L-26,59 L-27,59 L-27,60 L-28,60 L-28,61 L-29,61 L-29,62 L-30,62 L-30,63 L-31,63 L-31,65 L-32,65 L-32,67 L-33,67 L-33,68 L-34,68 L-34,70 L-35,70 L-35,73 L-36,73 L-36,77 L-37,77 L-37,81 L-38,81 L-38,86 L-39,86 L-39,103 L-38,103 L-38,105 L-37,105 L-37,106 L-36,106 L-36,107 L-34,107 L-34,108 L-28,108 L-28,107 L-26,107 L-26,106 L-24,106 L-24,105 L-23,105 L-23,104 L-22,104 L-22,103 L-21,103 L-21,101 L-20,101 L-20,100 L-19,100 L-19,99 L-18,99 L-18,97 L-17,97 L-17,95 L-16,95 L-16,91 L-15,91 L-15,86 L-14,86 L-14,81 L-13,81 L-13,75 L-12,75 L-12,69 L-11,69 L-11,59 L-12,59 L-12,58 L-13,58 L-13,57 L-14,57 L-14,56 L-17,56 L-17,55 Z ",
    fill: "#004FD5",
    transform: "translate(827,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L2,1 L2,0 L3,0 L3,1 L6,1 L6,0 L9,0 L9,1 L10,1 L10,0 L11,0 L11,1 L14,1 L14,0 L19,0 L19,1 L20,1 L20,0 L35,0 L35,1 L36,1 L36,0 L40,0 L40,1 L41,1 L41,0 L45,0 L45,1 L46,1 L46,129 L45,129 L45,131 L44,131 L44,130 L0,130 L0,128 L-1,128 L-1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(301,44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L27,0 L27,1 L28,1 L28,2 L27,2 L27,7 L26,7 L26,14 L25,14 L25,19 L24,19 L24,25 L23,25 L23,33 L22,33 L22,38 L21,38 L21,44 L20,44 L20,50 L19,50 L19,56 L18,56 L18,66 L19,66 L19,67 L20,67 L20,68 L22,68 L22,69 L23,69 L23,68 L27,68 L27,67 L29,67 L29,66 L31,66 L31,65 L32,65 L32,64 L33,64 L33,63 L34,63 L34,61 L35,61 L35,60 L36,60 L36,58 L37,58 L37,55 L38,55 L38,49 L39,49 L39,43 L40,43 L40,36 L41,36 L41,30 L42,30 L42,24 L43,24 L43,18 L44,18 L44,12 L45,12 L45,4 L46,4 L46,0 L72,0 L72,5 L71,5 L71,12 L70,12 L70,18 L69,18 L69,25 L68,25 L68,30 L67,30 L67,37 L66,37 L66,42 L65,42 L65,49 L64,49 L64,55 L63,55 L63,61 L62,61 L62,68 L61,68 L61,74 L60,74 L60,81 L59,81 L59,89 L58,89 L58,90 L56,90 L56,89 L36,89 L36,90 L34,90 L34,89 L33,89 L33,87 L34,87 L34,81 L35,81 L35,78 L34,78 L34,79 L33,79 L33,80 L32,80 L32,81 L31,81 L31,82 L30,82 L30,83 L29,83 L29,84 L28,84 L28,85 L27,85 L27,86 L25,86 L25,87 L24,87 L24,88 L22,88 L22,89 L20,89 L20,90 L18,90 L18,91 L15,91 L15,92 L2,92 L2,91 L-1,91 L-1,90 L-2,90 L-2,89 L-4,89 L-4,88 L-5,88 L-5,87 L-6,87 L-6,86 L-7,86 L-7,84 L-8,84 L-8,82 L-9,82 L-9,79 L-10,79 L-10,62 L-9,62 L-9,55 L-8,55 L-8,49 L-7,49 L-7,43 L-6,43 L-6,36 L-5,36 L-5,31 L-4,31 L-4,24 L-3,24 L-3,19 L-2,19 L-2,12 L-1,12 L-1,6 L-2,6 L-2,5 L0,5 Z ",
    fill: "#004FD6",
    transform: "translate(692,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L15,0 L15,1 L19,1 L19,2 L22,2 L22,3 L25,3 L25,4 L26,4 L26,5 L28,5 L28,6 L29,6 L29,7 L30,7 L30,8 L32,8 L32,9 L33,9 L33,10 L34,10 L34,11 L35,11 L35,13 L36,13 L36,14 L37,14 L37,16 L38,16 L38,18 L39,18 L39,21 L40,21 L40,24 L41,24 L41,30 L42,30 L42,42 L41,42 L41,49 L40,49 L40,53 L39,53 L39,58 L38,58 L38,61 L37,61 L37,64 L36,64 L36,66 L35,66 L35,68 L34,68 L34,70 L33,70 L33,72 L32,72 L32,74 L31,74 L31,76 L30,76 L30,77 L29,77 L29,78 L28,78 L28,79 L27,79 L27,80 L26,80 L26,81 L25,81 L25,82 L24,82 L24,83 L23,83 L23,84 L22,84 L22,85 L21,85 L21,86 L19,86 L19,87 L18,87 L18,88 L16,88 L16,89 L14,89 L14,90 L11,90 L11,91 L8,91 L8,92 L5,92 L5,93 L-13,93 L-13,92 L-18,92 L-18,91 L-20,91 L-20,90 L-22,90 L-22,89 L-24,89 L-24,88 L-26,88 L-26,87 L-27,87 L-27,86 L-28,86 L-28,85 L-29,85 L-29,84 L-30,84 L-30,83 L-31,83 L-31,82 L-32,82 L-32,81 L-33,81 L-33,79 L-34,79 L-34,78 L-35,78 L-35,76 L-36,76 L-36,74 L-37,74 L-37,71 L-38,71 L-38,66 L-39,66 L-39,47 L-38,47 L-38,41 L-37,41 L-37,37 L-36,37 L-36,34 L-35,34 L-35,30 L-34,30 L-34,28 L-33,28 L-33,26 L-32,26 L-32,24 L-31,24 L-31,22 L-30,22 L-30,20 L-29,20 L-29,19 L-28,19 L-28,17 L-27,17 L-27,16 L-26,16 L-26,15 L-25,15 L-25,14 L-24,14 L-24,12 L-23,12 L-23,11 L-21,11 L-21,10 L-20,10 L-20,9 L-19,9 L-19,8 L-18,8 L-18,7 L-17,7 L-17,6 L-15,6 L-15,5 L-13,5 L-13,4 L-11,4 L-11,3 L-8,3 L-8,2 L-6,2 L-6,1 L0,1 Z M2,20 L2,21 L0,21 L0,22 L-1,22 L-1,23 L-2,23 L-2,24 L-3,24 L-3,25 L-4,25 L-4,26 L-5,26 L-5,27 L-6,27 L-6,29 L-7,29 L-7,31 L-8,31 L-8,34 L-9,34 L-9,36 L-10,36 L-10,40 L-11,40 L-11,45 L-12,45 L-12,53 L-13,53 L-13,59 L-12,59 L-12,66 L-11,66 L-11,68 L-10,68 L-10,70 L-9,70 L-9,71 L-7,71 L-7,72 L-5,72 L-5,73 L-2,73 L-2,72 L2,72 L2,71 L4,71 L4,70 L5,70 L5,69 L6,69 L6,68 L7,68 L7,66 L8,66 L8,65 L9,65 L9,63 L10,63 L10,61 L11,61 L11,59 L12,59 L12,56 L13,56 L13,52 L14,52 L14,45 L15,45 L15,29 L14,29 L14,25 L13,25 L13,23 L12,23 L12,22 L11,22 L11,21 L10,21 L10,20 Z ",
    fill: "#004ED4",
    transform: "translate(638,82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L27,0 L27,6 L26,6 L26,12 L25,12 L25,17 L24,17 L24,24 L23,24 L23,30 L22,30 L22,35 L21,35 L21,42 L20,42 L20,48 L19,48 L19,54 L18,54 L18,61 L17,61 L17,66 L16,66 L16,73 L15,73 L15,79 L14,79 L14,86 L13,86 L13,92 L12,92 L12,98 L11,98 L11,103 L10,103 L10,109 L9,109 L9,116 L8,116 L8,122 L7,122 L7,127 L3,127 L3,126 L-21,126 L-21,125 L-20,125 L-20,120 L-19,120 L-19,113 L-18,113 L-18,108 L-17,108 L-17,101 L-16,101 L-16,95 L-15,95 L-15,88 L-14,88 L-14,83 L-13,83 L-13,76 L-12,76 L-12,69 L-11,69 L-11,63 L-10,63 L-10,57 L-9,57 L-9,51 L-8,51 L-8,45 L-7,45 L-7,38 L-6,38 L-6,32 L-5,32 L-5,26 L-4,26 L-4,20 L-3,20 L-3,14 L-2,14 L-2,7 L-1,7 L-1,1 L0,1 Z ",
    fill: "#004FD7",
    transform: "translate(579,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L12,0 L12,2 L13,2 L13,4 L14,4 L14,6 L15,6 L15,8 L16,8 L16,10 L17,10 L17,12 L18,12 L18,14 L19,14 L19,16 L20,16 L20,18 L22,18 L22,16 L23,16 L23,14 L24,14 L24,12 L25,12 L25,10 L26,10 L26,8 L27,8 L27,6 L28,6 L28,4 L29,4 L29,2 L30,2 L30,0 L42,0 L42,35 L43,35 L43,36 L42,36 L42,39 L33,39 L33,38 L32,38 L32,34 L33,34 L33,28 L32,28 L32,27 L33,27 L33,18 L31,18 L31,20 L30,20 L30,22 L29,22 L29,24 L28,24 L28,26 L27,26 L27,28 L26,28 L26,30 L25,30 L25,32 L23,32 L23,33 L22,33 L22,34 L21,34 L21,32 L19,32 L19,33 L18,33 L18,32 L17,32 L17,30 L16,30 L16,28 L15,28 L15,26 L14,26 L14,24 L13,24 L13,22 L12,22 L12,20 L11,20 L11,18 L10,18 L10,19 L9,19 L9,22 L10,22 L10,28 L9,28 L9,31 L10,31 L10,35 L9,35 L9,37 L10,37 L10,38 L9,38 L9,39 L0,39 L0,26 L-1,26 L-1,25 L0,25 L0,20 L-1,20 L-1,19 L0,19 L0,18 L-1,18 L-1,17 L0,17 L0,10 L-1,10 L-1,9 L0,9 L0,6 L-1,6 L-1,5 L0,5 L0,4 L-1,4 L-1,1 L0,1 Z M32,16 L32,17 L33,17 L33,16 Z ",
    fill: "#010103",
    transform: "translate(551,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L11,0 L11,2 L12,2 L12,4 L13,4 L13,5 L14,5 L14,6 L15,6 L15,8 L16,8 L16,9 L17,9 L17,10 L18,10 L18,12 L19,12 L19,13 L20,13 L20,15 L21,15 L21,16 L22,16 L22,18 L23,18 L23,19 L24,19 L24,21 L25,21 L25,20 L26,20 L26,19 L25,19 L25,18 L26,18 L26,14 L25,14 L25,10 L26,10 L26,8 L25,8 L25,0 L35,0 L35,1 L36,1 L36,38 L35,38 L35,39 L26,39 L26,38 L25,38 L25,37 L24,37 L24,35 L23,35 L23,34 L22,34 L22,33 L21,33 L21,32 L20,32 L20,30 L19,30 L19,29 L18,29 L18,27 L17,27 L17,26 L16,26 L16,24 L15,24 L15,23 L14,23 L14,22 L13,22 L13,20 L12,20 L12,19 L11,19 L11,17 L10,17 L10,21 L9,21 L9,23 L10,23 L10,24 L9,24 L9,25 L10,25 L10,26 L9,26 L9,32 L10,32 L10,33 L9,33 L9,39 L0,39 L0,38 L-1,38 L-1,37 L0,37 L0,36 L-1,36 L-1,34 L0,34 L0,30 L-1,30 L-1,26 L0,26 L0,22 L-1,22 L-1,17 L0,17 L0,13 L-1,13 L-1,12 L0,12 L0,11 L-1,11 L-1,8 L0,8 L0,6 L-1,6 L-1,1 L0,1 Z M9,16 L9,17 L10,17 L10,16 Z ",
    fill: "#000001",
    transform: "translate(326,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,0 L10,1 L13,1 L13,2 L15,2 L15,3 L17,3 L17,4 L18,4 L18,3 L19,3 L19,5 L20,5 L20,6 L21,6 L21,7 L22,7 L22,9 L23,9 L23,10 L24,10 L24,13 L25,13 L25,17 L26,17 L26,23 L25,23 L25,27 L24,27 L24,29 L23,29 L23,31 L22,31 L22,33 L21,33 L21,34 L20,34 L20,35 L19,35 L19,36 L18,36 L18,37 L16,37 L16,38 L15,38 L15,39 L13,39 L13,40 L9,40 L9,41 L0,41 L0,40 L-4,40 L-4,39 L-7,39 L-7,38 L-8,38 L-8,37 L-9,37 L-9,36 L-10,36 L-10,35 L-11,35 L-11,34 L-12,34 L-12,33 L-13,33 L-13,32 L-14,32 L-14,30 L-15,30 L-15,27 L-16,27 L-16,14 L-15,14 L-15,12 L-14,12 L-14,10 L-13,10 L-13,8 L-12,8 L-12,7 L-11,7 L-11,6 L-10,6 L-10,5 L-9,5 L-9,4 L-8,4 L-8,3 L-6,3 L-6,2 L-3,2 L-3,1 L0,1 Z M2,9 L2,10 L-1,10 L-1,11 L-2,11 L-2,12 L-3,12 L-3,13 L-4,13 L-4,15 L-5,15 L-5,19 L-6,19 L-6,22 L-5,22 L-5,26 L-4,26 L-4,28 L-3,28 L-3,30 L-1,30 L-1,31 L1,31 L1,32 L8,32 L8,31 L10,31 L10,30 L11,30 L11,29 L12,29 L12,28 L13,28 L13,26 L14,26 L14,23 L15,23 L15,18 L14,18 L14,14 L13,14 L13,13 L11,13 L11,12 L9,12 L9,11 L10,11 L10,10 L8,10 L8,9 Z M11,11 L11,12 L12,12 L12,11 Z ",
    fill: "#010103",
    transform: "translate(470,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L21,0 L21,1 L25,1 L25,2 L28,2 L28,3 L29,3 L29,4 L30,4 L30,5 L31,5 L31,7 L32,7 L32,11 L33,11 L33,14 L32,14 L32,18 L31,18 L31,19 L30,19 L30,21 L29,21 L29,22 L27,22 L27,23 L26,23 L26,24 L24,24 L24,25 L25,25 L25,26 L26,26 L26,27 L27,27 L27,29 L28,29 L28,30 L29,30 L29,31 L30,31 L30,33 L31,33 L31,34 L32,34 L32,35 L33,35 L33,37 L35,37 L35,39 L23,39 L23,38 L21,38 L21,36 L20,36 L20,34 L19,34 L19,33 L18,33 L18,31 L17,31 L17,30 L16,30 L16,28 L15,28 L15,27 L14,27 L14,26 L10,26 L10,37 L11,37 L11,38 L10,38 L10,39 L0,39 L0,36 L-1,36 L-1,35 L0,35 L0,9 L-1,9 L-1,8 L0,8 L0,7 L-1,7 L-1,6 L0,6 L0,3 L-1,3 L-1,1 L0,1 Z M10,8 L10,18 L19,18 L19,17 L20,17 L20,16 L21,16 L21,14 L20,14 L20,12 L21,12 L21,10 L20,10 L20,9 L17,9 L17,8 L12,8 L12,9 L11,9 L11,8 Z ",
    fill: "#010204",
    transform: "translate(507,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L22,0 L22,1 L25,1 L25,2 L27,2 L27,3 L28,3 L28,4 L30,4 L30,6 L31,6 L31,8 L32,8 L32,17 L31,17 L31,19 L30,19 L30,20 L29,20 L29,21 L28,21 L28,22 L27,22 L27,23 L26,23 L26,24 L25,24 L25,26 L26,26 L26,27 L27,27 L27,29 L28,29 L28,30 L29,30 L29,31 L30,31 L30,33 L31,33 L31,34 L32,34 L32,35 L33,35 L33,37 L34,37 L34,40 L33,40 L33,39 L22,39 L22,38 L21,38 L21,36 L20,36 L20,34 L19,34 L19,33 L18,33 L18,32 L17,32 L17,30 L16,30 L16,29 L15,29 L15,27 L14,27 L14,26 L10,26 L10,27 L11,27 L11,28 L10,28 L10,39 L0,39 Z M10,8 L10,18 L18,18 L18,17 L20,17 L20,16 L21,16 L21,10 L20,10 L20,9 L15,9 L15,8 L12,8 L12,10 L11,10 L11,8 Z ",
    fill: "#000001",
    transform: "translate(231,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L13,0 L13,1 L14,1 L14,4 L15,4 L15,7 L16,7 L16,9 L17,9 L17,12 L18,12 L18,15 L19,15 L19,18 L20,18 L20,20 L21,20 L21,23 L22,23 L22,26 L23,26 L23,28 L24,28 L24,31 L25,31 L25,33 L26,33 L26,36 L27,36 L27,38 L28,38 L28,39 L16,39 L16,36 L15,36 L15,33 L14,33 L14,31 L13,31 L13,32 L9,32 L9,31 L0,31 L0,32 L-1,32 L-1,34 L-2,34 L-2,36 L-3,36 L-3,39 L-13,39 L-13,38 L-15,38 L-15,36 L-14,36 L-14,37 L-13,37 L-13,35 L-12,35 L-12,32 L-11,32 L-11,29 L-10,29 L-10,27 L-9,27 L-9,24 L-8,24 L-8,21 L-7,21 L-7,18 L-6,18 L-6,16 L-5,16 L-5,14 L-4,14 L-4,11 L-3,11 L-3,8 L-2,8 L-2,6 L-1,6 L-1,3 L0,3 Z M6,10 L6,13 L5,13 L5,17 L4,17 L4,19 L3,19 L3,22 L2,22 L2,23 L11,23 L11,20 L10,20 L10,17 L9,17 L9,15 L8,15 L8,12 L7,12 L7,10 Z ",
    fill: "#000001",
    transform: "translate(287,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,0 L8,1 L13,1 L13,2 L16,2 L16,4 L17,4 L17,11 L16,11 L16,12 L14,12 L14,11 L13,11 L13,10 L9,10 L9,9 L1,9 L1,10 L-1,10 L-1,14 L1,14 L1,15 L4,15 L4,16 L7,16 L7,17 L10,17 L10,18 L12,18 L12,19 L14,19 L14,20 L15,20 L15,21 L16,21 L16,22 L17,22 L17,23 L18,23 L18,27 L19,27 L19,29 L18,29 L18,33 L17,33 L17,35 L16,35 L16,36 L15,36 L15,37 L14,37 L14,38 L12,38 L12,39 L10,39 L10,40 L7,40 L7,41 L-3,41 L-3,40 L-8,40 L-8,39 L-11,39 L-11,38 L-13,38 L-13,32 L-12,32 L-12,29 L-10,29 L-10,30 L-8,30 L-8,31 L-3,31 L-3,32 L6,32 L6,31 L5,31 L5,29 L6,29 L6,28 L7,28 L7,27 L6,27 L6,26 L4,26 L4,25 L1,25 L1,24 L-2,24 L-2,23 L-5,23 L-5,22 L-7,22 L-7,21 L-9,21 L-9,20 L-10,20 L-10,19 L-11,19 L-11,18 L-12,18 L-12,14 L-13,14 L-13,11 L-12,11 L-12,7 L-11,7 L-11,6 L-10,6 L-10,5 L-9,5 L-9,4 L-8,4 L-8,3 L-6,3 L-6,2 L-4,2 L-4,1 L0,1 Z M7,28 L7,29 L8,29 L8,28 Z M6,30 L6,31 L7,31 L7,30 Z ",
    fill: "#020306",
    transform: "translate(618,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,0 L8,1 L13,1 L13,2 L16,2 L16,3 L17,3 L17,12 L15,12 L15,11 L13,11 L13,10 L9,10 L9,9 L1,9 L1,10 L-1,10 L-1,14 L1,14 L1,15 L4,15 L4,16 L7,16 L7,17 L10,17 L10,18 L12,18 L12,19 L14,19 L14,20 L16,20 L16,21 L17,21 L17,23 L18,23 L18,25 L19,25 L19,32 L18,32 L18,34 L17,34 L17,36 L16,36 L16,37 L14,37 L14,38 L13,38 L13,39 L11,39 L11,40 L7,40 L7,41 L-3,41 L-3,40 L-8,40 L-8,39 L-11,39 L-11,38 L-12,38 L-12,29 L-10,29 L-10,30 L-8,30 L-8,31 L-3,31 L-3,32 L6,32 L6,31 L8,31 L8,27 L7,27 L7,26 L4,26 L4,25 L0,25 L0,24 L-2,24 L-2,23 L-5,23 L-5,22 L-7,22 L-7,21 L-9,21 L-9,20 L-10,20 L-10,18 L-11,18 L-11,16 L-12,16 L-12,9 L-11,9 L-11,7 L-10,7 L-10,5 L-9,5 L-9,4 L-7,4 L-7,3 L-6,3 L-6,2 L-4,2 L-4,1 L0,1 Z ",
    fill: "#010102",
    transform: "translate(386,200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L30,0 L30,4 L31,4 L31,5 L30,5 L30,8 L29,8 L29,9 L13,9 L13,10 L10,10 L10,16 L11,16 L11,17 L12,17 L12,16 L13,16 L13,17 L28,17 L28,25 L25,25 L25,26 L10,26 L10,34 L11,34 L11,35 L10,35 L10,36 L11,36 L11,38 L10,38 L10,39 L0,39 L0,2 L-1,2 L-1,1 L0,1 Z ",
    fill: "#010102",
    transform: "translate(416,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L35,0 L35,1 L36,1 L36,2 L35,2 L35,9 L22,9 L22,39 L12,39 L12,38 L11,38 L11,37 L12,37 L12,35 L11,35 L11,34 L12,34 L12,18 L11,18 L11,16 L12,16 L12,15 L11,15 L11,9 L0,9 L0,8 L-1,8 L-1,7 L0,7 L0,5 L-1,5 L-1,4 L0,4 L0,3 L-1,3 L-1,1 L0,1 Z ",
    fill: "#000001",
    transform: "translate(186,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,8 L0,8 L0,14 L-1,14 L-1,19 L-2,19 L-2,25 L-3,25 L-3,32 L-4,32 L-4,37 L-5,37 L-5,43 L-6,43 L-6,50 L-7,50 L-7,56 L-8,56 L-8,63 L-9,63 L-9,69 L-10,69 L-10,76 L12,76 L12,77 L14,77 L14,71 L15,71 L15,64 L16,64 L16,59 L17,59 L17,68 L16,68 L16,74 L15,74 L15,79 L11,79 L11,78 L-13,78 L-13,77 L-12,77 L-12,72 L-11,72 L-11,65 L-10,65 L-10,60 L-9,60 L-9,53 L-8,53 L-8,47 L-7,47 L-7,40 L-6,40 L-6,35 L-5,35 L-5,28 L-4,28 L-4,21 L-3,21 L-3,15 L-2,15 L-2,9 L-1,9 L-1,3 L0,3 Z ",
    fill: "#0338A5",
    transform: "translate(571,94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,4 L0,4 L0,11 L-1,11 L-1,16 L-2,16 L-2,22 L-3,22 L-3,30 L-4,30 L-4,35 L-5,35 L-5,41 L-6,41 L-6,47 L-7,47 L-7,53 L-8,53 L-8,63 L-7,63 L-7,64 L-6,64 L-6,65 L-4,65 L-4,66 L-3,66 L-3,65 L1,65 L1,64 L3,64 L3,63 L5,63 L5,62 L6,62 L6,61 L7,61 L7,60 L8,60 L8,58 L9,58 L9,57 L10,57 L10,55 L11,55 L11,52 L12,52 L12,49 L13,49 L13,54 L12,54 L12,56 L11,56 L11,58 L10,58 L10,60 L9,60 L9,61 L8,61 L8,62 L7,62 L7,63 L6,63 L6,64 L5,64 L5,65 L3,65 L3,66 L1,66 L1,67 L-7,67 L-7,66 L-8,66 L-8,64 L-9,64 L-9,61 L-10,61 L-10,56 L-9,56 L-9,50 L-8,50 L-8,43 L-7,43 L-7,36 L-6,36 L-6,32 L-5,32 L-5,25 L-4,25 L-4,19 L-3,19 L-3,13 L-2,13 L-2,7 L-1,7 L-1,1 L0,1 Z ",
    fill: "#023BAB",
    transform: "translate(718,86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,7 L0,7 L0,13 L-1,13 L-1,14 L-3,14 L-3,13 L-5,13 L-5,12 L-6,12 L-6,11 L-8,11 L-8,10 L-11,10 L-11,9 L-26,9 L-26,10 L-30,10 L-30,11 L-32,11 L-32,12 L-34,12 L-34,13 L-36,13 L-36,14 L-37,14 L-37,15 L-39,15 L-39,16 L-40,16 L-40,17 L-41,17 L-41,18 L-42,18 L-42,19 L-43,19 L-43,20 L-44,20 L-44,21 L-45,21 L-45,22 L-46,22 L-46,24 L-47,24 L-47,25 L-48,25 L-48,26 L-49,26 L-49,28 L-50,28 L-50,30 L-51,30 L-51,32 L-52,32 L-52,34 L-53,34 L-53,36 L-54,36 L-54,39 L-55,39 L-55,41 L-56,41 L-56,46 L-57,46 L-57,49 L-58,49 L-58,53 L-59,53 L-59,46 L-58,46 L-58,43 L-57,43 L-57,39 L-56,39 L-56,37 L-55,37 L-55,35 L-54,35 L-54,32 L-53,32 L-53,30 L-52,30 L-52,28 L-51,28 L-51,27 L-50,27 L-50,25 L-49,25 L-49,24 L-48,24 L-48,22 L-47,22 L-47,21 L-46,21 L-46,20 L-45,20 L-45,19 L-44,19 L-44,17 L-43,17 L-43,16 L-41,16 L-41,15 L-40,15 L-40,14 L-39,14 L-39,13 L-37,13 L-37,12 L-35,12 L-35,11 L-34,11 L-34,10 L-32,10 L-32,9 L-28,9 L-28,8 L-23,8 L-23,7 L-13,7 L-13,8 L-10,8 L-10,9 L-7,9 L-7,10 L-5,10 L-5,11 L-3,11 L-3,12 L-2,12 L-2,10 L-1,10 L-1,4 L0,4 Z ",
    fill: "#033CB0",
    transform: "translate(822,75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L26,0 L26,5 L25,5 L25,12 L24,12 L24,18 L23,18 L23,25 L22,25 L22,30 L21,30 L21,33 L20,33 L20,26 L21,26 L21,22 L22,22 L22,15 L23,15 L23,9 L24,9 L24,2 L1,2 L1,9 L0,9 L0,15 L-1,15 L-1,21 L-2,21 L-2,26 L-3,26 L-3,18 L-2,18 L-2,12 L-1,12 L-1,4 L0,4 Z ",
    fill: "#033DAF",
    transform: "translate(738,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,9 L0,9 L0,15 L-1,15 L-1,22 L-2,22 L-2,30 L-3,30 L-3,31 L-5,31 L-5,30 L-25,30 L-25,31 L-27,31 L-27,30 L-28,30 L-28,28 L-27,28 L-27,22 L-26,22 L-26,21 L-25,21 L-25,28 L-4,28 L-4,24 L-3,24 L-3,18 L-2,18 L-2,11 L-1,11 L-1,5 L0,5 Z ",
    fill: "#043CAC",
    transform: "translate(753,142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,6 L0,6 L0,23 L1,23 L1,25 L2,25 L2,26 L3,26 L3,27 L5,27 L5,28 L11,28 L11,27 L13,27 L13,26 L15,26 L15,25 L16,25 L16,24 L17,24 L17,23 L18,23 L18,21 L19,21 L19,20 L20,20 L20,19 L21,19 L21,17 L22,17 L22,15 L23,15 L23,11 L24,11 L24,6 L25,6 L25,4 L26,4 L26,9 L25,9 L25,13 L24,13 L24,16 L23,16 L23,18 L22,18 L22,20 L21,20 L21,21 L20,21 L20,23 L19,23 L19,24 L18,24 L18,25 L17,25 L17,26 L16,26 L16,27 L14,27 L14,28 L13,28 L13,29 L9,29 L9,30 L5,30 L5,29 L3,29 L3,28 L1,28 L1,27 L0,27 L0,25 L-1,25 L-1,21 L-2,21 L-2,10 L-1,10 L-1,3 L0,3 Z ",
    fill: "#023DB2",
    transform: "translate(788,126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,0 L7,1 L8,1 L8,0 L24,0 L24,1 L25,1 L25,0 L26,0 L26,8 L25,8 L25,12 L24,12 L24,5 L25,5 L25,2 L1,2 L1,3 L0,3 L0,10 L-1,10 L-1,17 L-2,17 L-2,24 L-3,24 L-3,28 L-4,28 L-4,20 L-3,20 L-3,14 L-2,14 L-2,7 L-1,7 L-1,1 L0,1 Z ",
    fill: "#0639A0",
    transform: "translate(827,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,8 L0,8 L0,15 L-1,15 L-1,20 L-2,20 L-2,27 L-3,27 L-3,33 L-4,33 L-4,40 L-5,40 L-5,46 L-6,46 L-6,52 L-7,52 L-7,57 L-8,57 L-8,60 L-9,60 L-9,58 L-10,58 L-10,53 L-8,53 L-8,49 L-7,49 L-7,43 L-6,43 L-6,35 L-5,35 L-5,30 L-4,30 L-4,22 L-3,22 L-3,17 L-2,17 L-2,10 L-1,10 L-1,4 L0,4 Z ",
    fill: "#0140B5",
    transform: "translate(597,92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,0 L5,1 L2,1 L2,2 L-1,2 L-1,3 L-4,3 L-4,4 L-5,4 L-5,5 L-7,5 L-7,6 L-9,6 L-9,7 L-10,7 L-10,8 L-11,8 L-11,9 L-12,9 L-12,10 L-13,10 L-13,11 L-14,11 L-14,12 L-15,12 L-15,13 L-16,13 L-16,14 L-17,14 L-17,15 L-18,15 L-18,17 L-19,17 L-19,18 L-20,18 L-20,20 L-21,20 L-21,21 L-22,21 L-22,23 L-23,23 L-23,26 L-24,26 L-24,28 L-25,28 L-25,30 L-26,30 L-26,34 L-27,34 L-27,37 L-28,37 L-28,42 L-29,42 L-29,47 L-30,47 L-30,39 L-29,39 L-29,35 L-28,35 L-28,32 L-27,32 L-27,28 L-26,28 L-26,26 L-25,26 L-25,24 L-24,24 L-24,22 L-23,22 L-23,20 L-22,20 L-22,18 L-21,18 L-21,17 L-20,17 L-20,15 L-19,15 L-19,14 L-18,14 L-18,13 L-17,13 L-17,12 L-16,12 L-16,10 L-15,10 L-15,9 L-13,9 L-13,8 L-12,8 L-12,7 L-11,7 L-11,6 L-10,6 L-10,5 L-9,5 L-9,4 L-7,4 L-7,3 L-5,3 L-5,2 L-3,2 L-3,1 L0,1 Z ",
    fill: "#033BA8",
    transform: "translate(630,84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L27,0 L27,1 L28,1 L28,2 L27,2 L27,3 L26,3 L26,2 L25,2 L25,1 L0,1 Z ",
    fill: "#0446C0",
    transform: "translate(692,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L2,3 L2,5 L3,5 L3,7 L4,7 L4,8 L6,8 L6,9 L8,9 L8,10 L13,10 L13,11 L5,11 L5,10 L4,10 L4,9 L3,9 L3,8 L2,8 L2,7 L1,7 L1,4 L0,4 Z ",
    fill: "#003CAC",
    transform: "translate(625,145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,6 L0,6 L0,8 L5,8 L5,9 L1,9 L1,10 L-1,10 L-1,9 L-2,9 L-2,7 L-1,7 L-1,1 L0,1 Z ",
    fill: "#073EAD",
    transform: "translate(727,163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L3,1 L3,4 L2,4 L2,8 L1,8 L1,7 L0,7 L0,9 L-1,9 L-1,3 L0,3 Z ",
    fill: "#0049C9",
    transform: "translate(788,119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,7 L0,7 Z ",
    fill: "#000000",
    transform: "translate(384,134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,0 L5,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(256,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,4 L0,4 Z ",
    fill: "#000000",
    transform: "translate(170,168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,4 L0,4 Z ",
    fill: "#000000",
    transform: "translate(384,125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L2,1 L2,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(288,198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L1,2 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(383,171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#002AFF",
    transform: "translate(843,120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(384,102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(384,86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L-1,2 L-1,1 L0,1 Z ",
    fill: "#003FE9",
    transform: "translate(819,81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,3 L0,3 Z ",
    fill: "#000000",
    transform: "translate(170,71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(533,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(359,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(327,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(278,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(267,238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(363,236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(358,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#00006A",
    transform: "translate(471,198)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#0000FF",
    transform: "translate(814,173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#002AFF",
    transform: "translate(724,164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#0000FF",
    transform: "translate(682,135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#003FBF",
    transform: "translate(457,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,115)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#0000FF",
    transform: "translate(845,106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#003FBF",
    transform: "translate(464,93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(384,82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#003FFF",
    transform: "translate(820,76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,1 L0,1 Z ",
    fill: "#003FFF",
    transform: "translate(815,75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,2 L0,2 Z ",
    fill: "#000000",
    transform: "translate(170,50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(900,284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(503,276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#555555",
    transform: "translate(724,272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(866,262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(866,254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(773,246)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(622,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(618,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(471,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(387,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(315,242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(598,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(591,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(559,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(551,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(541,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(424,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(422,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(418,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(354,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(311,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(239,241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(527,239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(266,239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(428,238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(603,237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(365,237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(503,236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(412,236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(372,236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(504,235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(366,235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(604,229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(479,229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(480,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(340,225)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007F7F",
    transform: "translate(724,224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(609,222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(337,222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(296,222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(291,222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(452,220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(630,217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007F7F",
    transform: "translate(724,216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(623,214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(372,212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(476,210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(494,209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007F7F",
    transform: "translate(724,208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(222,205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(284,204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(302,203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#00007F",
    transform: "translate(565,202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(463,201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(435,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(419,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(291,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(243,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(218,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(188,199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(504,195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007F7F",
    transform: "translate(724,184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(772,178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(641,176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(626,176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(527,176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(522,176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(498,176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(389,175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(288,175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(793,174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(773,174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007F7F",
    transform: "translate(618,174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(489,174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(542,173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(808,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(611,170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(719,169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0055AA",
    transform: "translate(837,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(286,157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(285,155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0055FF",
    transform: "translate(801,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(721,147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(541,147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(789,146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0055AA",
    transform: "translate(724,144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(223,141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,141)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(757,138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(678,138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(458,135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(865,134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(809,134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(681,131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(278,131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(270,131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(811,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(683,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(563,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(455,130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(269,127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(85,127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(456,126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(564,124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(681,122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(455,122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(793,118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(715,118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(630,117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(596,116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(844,114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(795,114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0055FF",
    transform: "translate(596,114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(497,113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(298,112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(597,110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(845,109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(597,108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(636,106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(812,103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(804,103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(718,101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(292,100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(677,98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0055FF",
    transform: "translate(501,98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(764,92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(689,92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(292,92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(672,91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(465,91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(384,90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(240,86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(785,85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(624,85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(509,84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(292,84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(816,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(91,83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(513,80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(289,80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(289,78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(820,72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(865,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(773,70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(820,68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(819,66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(820,60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(606,54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(162,54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(820,52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(298,48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(170,48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(469,47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(865,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(265,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(257,46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#00007F",
    transform: "translate(470,45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(916,44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#007FFF",
    transform: "translate(569,44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(564,44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(563,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(560,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(432,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(295,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(243,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(169,43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(270,40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(866,30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(819,25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#0000FF",
    transform: "translate(724,16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(270,8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(866,6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(771,5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(819,2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,1 L0,1 Z ",
    fill: "#000000",
    transform: "translate(724,0)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 241,
    fill: "#000000",
    fontFamily: "Arial Black, Impact, Arial, sans-serif",
    fontSize: 52,
    fontWeight: 900,
    letterSpacing: 7
  }, "PLATFORMS")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogo3);
export default __webpack_public_path__ + "static/media/site_logo_3.7122472c6ed613b241dc63c10ed4624d.svg";
export { ForwardRef as ReactComponent };